import React from "react";
import { Input } from "../../ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../../ui/select";
import { TREATMENTS, money, presetRate, rateError, splitGross } from "./constants";

/** Treatment picker plus the "VAT rate (%)" field that only a custom rate needs. */
export const VatRateSelect = ({ treatment, ratePercent, onChange, prefix, dark }) => {
  const isCustom = presetRate(treatment) === null;
  const err = isCustom ? rateError(treatment, ratePercent) : null;
  const bg = dark ? "bg-slate-900" : "bg-slate-800";
  return (
    <div className="space-y-1">
      <Select
        value={treatment}
        onValueChange={(v) => onChange({
          vat_treatment: v,
          // Seed the box with the old rate so switching to Custom is not blank.
          vat_rate_percent: presetRate(v) === null
            ? (ratePercent ?? presetRate(treatment) ?? "")
            : presetRate(v),
        })}>
        <SelectTrigger className={`${bg} border-slate-700 text-white h-9`}
                       data-testid={`${prefix}-treatment-select`}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {TREATMENTS.map((t) => (
            <SelectItem key={t.id} value={t.id}
                        data-testid={`${prefix}-treatment-opt-${t.id}`}>{t.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      {isCustom && (
        <>
          <Input type="number" step="0.01" min="0" max="100" placeholder="VAT rate (%) — 9 = 9%"
                 value={ratePercent ?? ""}
                 onChange={(e) => onChange({ vat_treatment: treatment,
                                             vat_rate_percent: e.target.value })}
                 className={`${bg} border-slate-700 text-white h-9`}
                 aria-label="VAT rate (%)"
                 data-testid={`${prefix}-rate-input`} />
          {err && (
            <p className="text-[11px] text-red-400" data-testid={`${prefix}-rate-error`}>{err}</p>
          )}
        </>
      )}
    </div>
  );
};

/** Live net / VAT / gross so the rate can be sanity-checked before saving. */
export const VatPreview = ({ gross, treatment, ratePercent, prefix }) => {
  const s = splitGross(gross, treatment, ratePercent);
  if (!s) return null;
  return (
    <p className="text-[11px] text-slate-400 font-mono" data-testid={`${prefix}-vat-preview`}>
      net {money(s.net)} · VAT {money(s.vat)} · gross {money(s.gross)}
      {s.selfAccounted && <span className="text-slate-500"> (self-accounted)</span>}
    </p>
  );
};

export default VatRateSelect;
